export default __webpack_public_path__ + "static/baner-2-98edabdb18eb3fdd192d849784bdfab6.png";